<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="entregaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="entrega">
                    <div class="modal-header">
                        <h5 class="modal-title">Registrar Entrega</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="lead mb-3" v-if="entrega.atendimento_procedimento.atendimento.paciente">
                            {{ entrega.atendimento_procedimento.atendimento.paciente.st_nome }}
                        </div>

                        <div class="alert alert-info mb-3">
                            <celula-dados-procedimento :blockanexos="true" :hor="dados_procedimento(entrega)" />
                            <div>{{ $util.getFormatDate(entrega.dt_inclusao) }} {{ entrega.dt_inclusao.substr(11,5) }}</div>
                            <div>#{{ entrega.atendimento_procedimento.id_atendimento }}
                                <span v-if="entrega.atendimento_procedimento.atendimento && entrega.atendimento_procedimento.atendimento.marcacao && entrega.atendimento_procedimento.atendimento.marcacao.st_id_externo" class="ml-2 small text-muted">
                                    {{ entrega.atendimento_procedimento.atendimento.marcacao.st_id_externo }}
                                </span>    
                            </div>
                        </div>

                        <az-input
                            label="Entregar para"
                            placeholder="Nome..."
                            required
                            :validate="validate"
                            v-if="!cancelando"
                            v-model="entregar_para">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                                        @click="definir_paciente()">
                                        <i class="fas fa-equals mr-2"></i>
                                        Paciente
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <div class="mt-3" v-if="is_klis && lista_medicos && lista_medicos.length">
                            <div v-for="(medico, imx) in lista_medicos" :key="imx">
                                <az-input 
                                    type="checkbox-group"
                                    :label="medico.search"
                                    v-model="medico.selec" 
                                    :edicao="lista_medicos.length > 1" />
                            </div>
                        </div>

                        <div v-if="is_klis" class="mt-3">
                            <az-input   
                                sizing="sm"
                                label="Servidor de Impressão"
                                placeholder="Sem sevidor de impressão..."
                                v-model="servidor_impressao" />
                        </div>

                        <div class="progress mt-3 mb-3">
                            <div class="indeterminate" v-if="!entrega.laudo_entregas"></div>
                            <div class="determinate" v-else></div>
                        </div>    

                        <template v-if="entrega.laudo_entregas && entrega.laudo_entregas.length">
                            <div class="alert alert-secondary mt-3 mb-1 d-flex justify-content-between">
                                <div>Entregas Realizadas</div>
                                <div>
                                    <span class="badge badge-secondary">
                                        {{ entrega.laudo_entregas.length }}
                                    </span>
                                </div>
                            </div>
                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between" v-for="(entrega_feita, iex) in entrega.laudo_entregas" :key="iex">
                                    <div>
                                        <div>{{ entrega_feita.st_nome_recebedor }}</div>
                                        <div class="small" v-if="entrega_feita.created_at">
                                            em {{ $util.getFormatDate(entrega_feita.created_at) }} 
                                            {{ entrega_feita.created_at.substr(11,5) }}
                                            por {{ entrega_feita.usuario.st_login }}</div>
                                        <div class="small text-muted">{{ entrega_feita.st_local }}</div>
                                    </div>
                                    <div>
                                        <a href='#' class="card-link text-danger" @click.prevent="cancelar_entrega(entrega_feita)">
                                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </template>
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="entregar()">Registrar Entrega</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="printKlisPreviewModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" style="z-index:1000000000">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" v-if="link_preview">
                    <div class="modal-body">
                        <az-loading class="my-3" msg="Aguarde..." v-if="!iframe_src" />
                        
                        <div class="embed-responsive embed-responsive embed-responsive-4by3" v-if="iframe_src" v-show="false">
                            <iframe id="pdf-print-preview-klis" 
                            class="embed-responsive-item" 
                            :src="iframe_src" 
                            @load="confirmar()" 
                            @afterprint="fechar()" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";
import AzSubmit from '../../util/AzSubmit.vue';
import AzLoading from '../../util/AzLoading.vue';

export default {
    data() { 
        return { 
            entrega: null, 
            entregar_para: null, 
            validate: false, 
            cancelando: false, 
            is_klis: false, 
            lista_medicos: null, 
            iframe_src: "", 
            link_preview: false, 
            servidor_impressao: "", 
            lista_impressao: [], 
        };
    },

    components: { 
        AzInput, 
        CelulaDadosProcedimento, 
        AzSubmit, 
        AzLoading, 
    },
    
    props: ['paciente', 'timbrado'],

    methods: { 
        fechar () { 
            alert('Fechar!');
        },

        confirmar() { 
            /*
            this.$nextTick(() => { 
                setTimeout(() => { 
                    $('#printPreviewModal').modal('hide');
                }, 1000);
                
                $('#printPreviewModal').modal('hide');
            });

            $('#printPreviewModal').modal('hide');    
            */

            let id = 'pdf-print-preview-klis';
            var iframe = document.frames ? document.frames[id] : document.getElementById(id);
            var ifWin = iframe.contentWindow || iframe;
            iframe.focus();
            ifWin.print();

            return false;
        },

        cancelar_entrega (entrega) { 
            if ( !confirm('Confirma cancelar a entrega do resultado?') ) 
                return;

            this.cancelando = true;

            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'cancelar_entrega',
                dados: { 
                    id_laudo_entrega: entrega.id_laudo_entrega,
                },
                modal: 'entregaModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                },
                final: () => { 
                    this.validate = false;
                    this.cancelando = false;
                }
            });
        },

        definir_paciente () { 
            const paciente = this.paciente ? this.paciente : this.entrega.atendimento_procedimento.atendimento.paciente;

            if ( paciente ) { 
                this.entregar_para = ( paciente.st_nome_social ? paciente.st_nome_social : paciente.st_nome );
            }
        },

        blobToDataURL(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result); 
                    //resolve(reader.result.split(',')[1]);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },

        imprimir_proximo (todos = false) { 

            let ms = ""; 

            if ( todos ) { 

                ms = this.lista_medicos.filter(medico => medico.selec)
                    .map(medico => medico.id_medico_solicitante ? medico.id_medico_solicitante : '')
                    .filter(medico => medico)
                    .join(',');

                this.lista_impressao = []; 

            } else { 

                let medico = this.lista_impressao.shift();

                if ( medico.selec ) {
                    ms = medico.id_medico_solicitante ? medico.id_medico_solicitante : '';
                }

            }
 
            

            if ( ms ) { 

                let link = '/imprimir/klis/' + this.entrega.atendimento_procedimento.atendimento.marcacao.id_marcacao + 
                    '?ms=' + ms + 
                    '&si=' + encodeURIComponent(this.servidor_impressao) + 
                    '&t=' + ( this.timbrado ? 1 : 0 );

                const base = this.axios.defaults.baseURL;
                const redir = ( base.substr(0,5) == 'https' )
                    ? ( 'https://api-relatorio.klingo.app/api'
                            + ( link.substr(0,1) == '/' ? '' : '/' ) ) 
                    : '';
                
                this.axios.get(redir + link, {
                        data: {},
                        responseType: 'arraybuffer'
                    })
                    .then(response => {

                        if(response.headers && response.headers["content-type"] == "application/json") {

                            let string = new TextDecoder().decode(response.data);
                            let obj = JSON.parse(string);

                            if ( obj && obj.msg ) { 
                                this.$toast.add({ 
                                    severity: ( obj.status_code == 200 ? 'success' : 'error' ),
                                    summary: 'Entregar Resultado',
                                    detail: obj.msg,
                                    life: 3000
                                });
                            }

                        } else { 

                            // convertar pra base 64
                            console.log('PDF:', response);

                            const blob = new Blob([response.data], { type: 'application/pdf' });
                            const url = window.URL.createObjectURL(blob);

                            console.log('URL:', url);

                            this.iframe_src = url;

                        }

                    })
                    .finally(() => { 
                        if ( this.lista_impressao.length ) { 

                            this.imprimir_proximo();

                        } else { 

                            this.$store.commit('loading', false);

                            this.$nextTick(() => { 
                                setTimeout(() => { 
                                    $('#printKlisPreviewModal').modal('hide');
                                }, 1000);
                                
                                $('#printKlisPreviewModal').modal('hide');
                            });

                            $('#printKlisPreviewModal').modal('hide');    

                        }
                    });

            }

        },

        entregar() { 
            this.iframe_src = null;

            if ( this.is_klis ) { 

                if ( this.lista_medicos && this.lista_medicos.length ) { 

                    if ( !this.lista_medicos.find(medico => medico.selec) ) { 
                        this.$toast.add({
                            severity: "warn",
                            summary: 'Entregar Resultado',
                            detail: "Selecione o profissional solicitante.",
                            life: 3000
                        });

                        return;
                    } 

                    this.lista_impressao = _.cloneDeep(this.lista_medicos.filter(medico => medico.selec));

                } else { 

                    console.log('Entregar... 222');

                    this.lista_impressao({ 
                        id_medico_solicitante: "", 
                        selec: true, 
                        nome: 'Sem Médico Solicitante', 
                    });

                }

            }

            this.$util.setCookie('ersi', this.servidor_impressao);

            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'entregar',
                dados: { 
                    id_laudo: this.entrega.id_laudo,
                    entregar_para: this.entregar_para,  
                    local: 'entrega-resultado',
                    si: this.servidor_impressao, 
                    klis: this.is_klis, 
                },
                modal: 'entregaModal',
                toast: this.is_klis ? false : true, 
                callback: () => { 
                    this.$emit('refresh');

                    if ( this.is_klis && this.lista_impressao && this.lista_impressao.length ) { 

                        $('#printKlisPreviewModal').modal('show');

                        this.link_preview = true; 

                        this.$nextTick(() => { 
                            this.imprimir_proximo(true);
                        });
                    
                    }

                } 

            });
        },

        registrar_entrega(item, medicos = null) { 
            this.is_klis = _.get(item, 'atendimento_procedimento.amostra_atendimento_procedimento.amostra.terceiro.st_classe') == 'terceiroKlis';
            this.lista_medicos = ( medicos && medicos.length ) 
                ? medicos 
                : [
                    { 
                        search: 'Sem médico solicitante', 
                        selec: true, 
                    }
                ];

            this.link_preview = false;
            this.servidor_impressao = this.$util.getCookie('ersi');

            if ( this.lista_medicos && this.lista_medicos.length == 1 ) {
                this.lista_medicos[0].selec = true;
            }

            if ( this.entrega ) { 
                if ( this.entrega.atendimento_procedimento.atendimento.id_paciente != 
                    item.atendimento_procedimento.atendimento.id_paciente ) { 

                    this.entregar_para = "";

                }
            }

            this.entrega = _.cloneDeep(item);
            this.validate = false;
            
            this.$nextTick(() => { 
                $('#entregaModal').modal('show');

                if ( !this.entrega.laudo_entregas ) { 

                    this.$util.loadItem(this, {
                        service: 'laudos',
                        parms: { 
                            id: item.id_laudo,
                            with: ['laudoEntregas.usuario'],
                        },
                    })
                    .then(res => { 
                        this.entrega.laudo_entregas = res.laudo_entregas;
                        this.$forceUpdate();
                    });

                }
                
            });
        },

        dados_procedimento(laudo) { 
            return { 
                marcacao: { 
                    procedimento: laudo.atendimento_procedimento.procedimento,
                    medico: laudo.atendimento_procedimento.atendimento.medico, 
                    arquivos: laudo.atendimento_procedimento.atendimento.marcacao.arquivos,
                    doc_pre_atends: laudo.atendimento_procedimento.atendimento.marcacao.doc_pre_atends, 
                    unidade_operacao: laudo.atendimento_procedimento.atendimento.marcacao.unidade_operacao, 
                }
            };
        },

    },

}
</script>